import React from 'react';
import ChevronIcon from '../icons/ChevronIcon';
import ColumnMenu from '../ColumnMenu';
import {
    ColumnHeader as Header,
    ColumnTitle,
    DragHandle,
    HeaderControls,
    CollapseButton,
    VerticalTitle
} from '../../styles/Column.styles';

const ColumnHeader = ({
    isCollapsed,
    title,
    isEditing,
    cardCount,
    dragHandleProps,
    handleTitleChange,
    handleTitleBlur,
    handleTitleKeyPress,
    handleTitleClick,
    handleCollapse,
    column,
    onArchiveAllCards,
    onDeleteColumn,
    onExportList
}) => {
    if (isCollapsed) {
        return (
            <Header isCollapsed={isCollapsed}>
                <VerticalTitle>{title} <span className="card-count-badge">{cardCount}</span></VerticalTitle>
                <CollapseButton
                    onClick={handleCollapse}
                    title="Expand"
                >
                    <ChevronIcon direction="right" />
                </CollapseButton>
            </Header>
        );
    }

    return (
        <Header isCollapsed={isCollapsed}>
            <DragHandle {...dragHandleProps}>⋮⋮</DragHandle>
            <ColumnTitle
                value={title}
                onChange={handleTitleChange}
                onBlur={handleTitleBlur}
                onKeyPress={handleTitleKeyPress}
                onClick={handleTitleClick}
                readOnly={!isEditing}
                autoFocus={isEditing}
            />
            <span className="card-count-badge">{cardCount}</span>
            <HeaderControls>
                <CollapseButton
                    onClick={handleCollapse}
                    title="Collapse"
                >
                    <ChevronIcon direction="left" />
                </CollapseButton>
                <ColumnMenu
                    column={column}
                    onArchiveAll={() => onArchiveAllCards(column.id)}
                    onDeleteColumn={() => onDeleteColumn(column.id)}
                    onExportList={onExportList}
                />
            </HeaderControls>
        </Header>
    );
};

export default ColumnHeader;